export const perfisUsuario = [
  { value: "Administrador", label: "Administrador" },
  { value: "Usuario", label: "Usuário" },
];

export const metodosHttp = ["Get", "Post", "Put", "Patch", "Delete"];

export const tiposAgendamento = [
  { value: "Diario", label: "Diário" },
  { value: "Semanal", label: "Semanal" },
  { value: "Quinzenal", label: "Quinzenal" },
  { value: "Mensal", label: "Mensal" },
  { value: "Cron", label: "Cron" },
];

export const diasSemana = [
  { value: "Sunday", label: "Domingo" },
  { value: "Monday", label: "Segunda" },
  { value: "Tuesday", label: "Terça" },
  { value: "Wednesday", label: "Quarta" },
  { value: "Thursday", label: "Quinta" },
  { value: "Friday", label: "Sexta" },
  { value: "Saturday", label: "Sábado" },
];

export const tiposParametro = [
  { value: "QueryString", label: "Query string" },
  { value: "Header", label: "Header" },
  { value: "BodyJson", label: "Body JSON" },
];
